<h1 mat-dialog-title>Conferma Eliminazione</h1>
<div mat-dialog-content>
  <p>Sei sicuro di voler eliminare questo evento?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Annulla</button>
  <button mat-button [mat-dialog-close]="true">Conferma</button>
</div>